import { BootFileParams, BootFn } from '@niknevis/vue-modules/types'
import { UserBoot } from '@/modules/user/use-cases/shared/user-boot.use-case'

const boot: BootFn = async function boot(ctx: BootFileParams) {
  // @ts-ignore
  await UserBoot.init()
}

export default boot
